import React from 'react';
import { LangContext } from '../../contexts/LangContext';
import './PurchaseHistory.css';

export default function PurchaseHistory({ historic = [], onClose }) {
  const { lang, t } = React.useContext(LangContext);
  const ph = t.component.purchaseHistory;

  const locale = lang === 'USD' ? 'en-US' : 'pt-BR';

  const fmt = (row) => {
    if (!row.date) return '—';
    const d = new Date(row.date);
    return `${d.toLocaleDateString(locale)} ${d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })}`;
  };

  const fmtPrice = (row) => {
    const val = (row.price || 0) / 100;
    const currency = row.currencyCode === 'USD' ? 'USD' : 'BRL';
    return val.toLocaleString(locale, { style: 'currency', currency });
  };

  return (
    <div className="ph-overlay" onClick={onClose}>
      <div className="ph-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ph-header">
          <span className="ph-header-title">{ph.title}</span>
          <button className="ph-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="ph-body">
          {historic.length === 0 ? (
            <p className="ph-empty">{ph.empty}</p>
          ) : (
            <table className="ph-table">
              <thead>
                <tr className="ph-thead">
                  <th className="ph-th">{ph.date}</th>
                  <th className="ph-th">{ph.pack}</th>
                  <th className="ph-th">{ph.price}</th>
                  <th className="ph-th">{ph.qty}</th>
                  <th className="ph-th">{ph.gateway}</th>
                  <th className="ph-th">{ph.server}</th>
                  <th className="ph-th">{ph.status}</th>
                </tr>
              </thead>
              <tbody>
                {historic
                  .slice()
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((row, i) => (
                    <tr key={i} className={i % 2 === 0 ? 'ph-tr' : 'ph-tr ph-tr-alt'}>
                      <td className="ph-td">{fmt(row)}</td>
                      <td className="ph-td">{row.name}</td>
                      <td className="ph-td">{fmtPrice(row)}</td>
                      <td className="ph-td">{row.packamount}</td>
                      <td className="ph-td">{row.gateway}</td>
                      <td className="ph-td">{row._server || '—'}</td>
                      <td className="ph-td">{ph.statusLabels[row.status] || row.status}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
